module.exports = __webpack_public_path__ + "static/media/nucleus-icon-white.2a65e31c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nucleus-icon-white.svg
// module id = 1614
// module chunks = 0